import createIcon from '../../createIcon';

/**
 * @component @name House
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOS44VjQuNUgxNlY3LjFMMTIgMy41TDIgMTIuNUg1VjIwLjVIMTBWMTQuNUgxNFYyMC41SDE5VjEyLjVIMjJMMTkgOS44Wk0xMCAxMC41QzEwIDkuNCAxMC45IDguNSAxMiA4LjVDMTMuMSA4LjUgMTQgOS40IDE0IDEwLjVIMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const House = createIcon('House', [
  [
    'path',
    {
      d: 'M19 9.8V4.5H16V7.1L12 3.5L2 12.5H5V20.5H10V14.5H14V20.5H19V12.5H22L19 9.8ZM10 10.5C10 9.4 10.9 8.5 12 8.5C13.1 8.5 14 9.4 14 10.5H10Z',
      key: '8fb6lw',
    },
  ],
]);

export default House;
